<template>
    <v-container fluid fill-height v-if="show_login">

        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md8>
                <v-card >
                    <v-toolbar dark color="teofly-login-header">
                        <v-toolbar-title>Login form</v-toolbar-title>
                    </v-toolbar>
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit" id="check-login-form">
                        <v-card-text>
                            <v-text-field
                                prepend-icon="person"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="email"
                                :rules="emailRules"
                                required
                            ></v-text-field>
                            <v-text-field
                                prepend-icon="lock"
                                name="password"
                                label="Password"
                                type="password"
                                v-model="password"
                                :rules="passwordRules"
                                required
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                type="submit"
                                class="orange-button"
                                :loading="loading"
                                :disabled="!valid || loading"
                            >Log In</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
export default {
    name: "Login",
    data () {
        return {
            email: '',
            password: '',
            valid: false,
            show_login: false,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required'
            ]
        }
    },
    computed: {
        loading () {
            return this.$store.getters.loading;
        },
        isAuthorized () {
            return this.$store.getters.isAuthorized;
        }
    },
    methods: {
        onSubmit (){
            if (this.$refs.form.validate()){
                const user = {
                    email: this.email,
                    password: this.password
                };
                this.$store.dispatch('loginUser', user)
                .then(() => {
                    if (this.isAuthorized) this.$router.push('/');
                })
                .catch(() => {});
            }
        }
    },
    created() {
        this.$vuetify.theme.dark = true;
        if (this.isAuthorized){
            this.$router.push('/');
        }
        else{
            this.show_login = true;
        }
    }
};
</script>
